import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    display: 'inline-block',
  },
  icon: {
    position: 'absolute',
    right: '-22px',
    top: '-3px',
    fontSize: '20px',
  },
  clickable: {
    cursor: 'pointer',
  },
}));